import {
  Box,
  Button,
  ComboboxItem,
  Grid,
  GridCol,
  MultiSelect,
  Select,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import {
  IconCheck,
  IconTransferIn,
  IconTransferOut,
  IconUserCode,
  IconX,
} from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { repositoryMdm, repositoryPos } from "../../_base/_const/_constVar";
import { SelectListItemBase } from "../../_base/model/_base/SelectListItemBase";
import { MessageResponse } from "../../model/MessageResponse";
import { getTblDmEmployeeAll } from "../../service/getSelectApi";
import { TransferManagerRequest } from "./RequestManagerTransfer";

interface ModalCreateRequestManagerTransferProps {
  onSuccess?: () => void;
  idEdit?: string;
}

const ModalCreateRequestManagerTransfer: React.FC<
  ModalCreateRequestManagerTransferProps
> = ({ onSuccess, idEdit }) => {
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const form = useForm<Partial<TransferManagerRequest>>({
    mode: "uncontrolled",
    initialValues: {
      nhanVienId: undefined,
      cnDiId: [],
      cnDenId: [],
    },
    validate: {
      nhanVienId: (value) => (!value ? "Vui lòng chọn nhân viên" : null),
      cnDiId: (value) =>
        !value || value.length === 0
          ? "Vui lòng chọn ít nhất một chi nhánh đi"
          : null,
      cnDenId: (value) =>
        !value || value.length === 0
          ? "Vui lòng chọn ít nhất một chi nhánh đến"
          : null,
    },
  });

  // Lấy danh sách nhân viên
  const getDataEmpSelect = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      setDataEmployee(res);
    }
  };

  // Lấy danh sách chi nhánh
  const fetchBranchCode = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<SelectListItemBase[]>
      >(`api/v1/TblDmInventory/get-select-branch?auth=true`);
      if (response && response.success) {
        setDataBranch(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    Promise.all([fetchBranchCode(), getDataEmpSelect()]);
  }, []);

  const handleSubmit = async (values: Partial<TransferManagerRequest>) => {
    setIsLoading(true);
    try {
      // Get branch codes for selected branches
      const sourceBranchCodes =
        values.cnDiId
          ?.map((id) => {
            const branch = dataBranch.find((b) => b.value === id);
            return branch?.att2 || "";
          })
          .filter((code) => code !== "") || [];

      const destBranchCodes =
        values.cnDenId
          ?.map((id) => {
            const branch = dataBranch.find((b) => b.value === id);
            return branch?.att2 || "";
          })
          .filter((code) => code !== "") || [];

      const payload = {
        id: idEdit !== undefined ? Number(idEdit) : 0,
        nhanVienId: values.nhanVienId,
        cnDiId: values.cnDiId || [],
        maCnDi: sourceBranchCodes,
        cnDenId: values.cnDenId || [],
        maCnDen: destBranchCodes,
      };
      let url =
        idEdit !== undefined
          ? `/api/v1/TblGrantTransferRights/update?id=${idEdit}`
          : "/api/v1/TblGrantTransferRights/create";
      const response = await repositoryMdm.post<MessageResponse<any>>(
        url,
        payload,
      );

      if (response?.success) {
        notifications.show({
          title: "Thành công",
          message: `${idEdit !== undefined ? "Chỉnh sửa" : "Tạo"} quyền chuyển kho thành công!`,
          color: "teal",
          icon: <IconCheck size={18} />,
        });
        modals.closeAll();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        notifications.show({
          title: "Lỗi",
          message:
            response?.message ||
            `Có lỗi xảy ra khi ${idEdit !== undefined ? "chỉnh sửa" : "tạo"} quyền chuyển kho!`,
          color: "red",
          icon: <IconX size={18} />,
        });
      }
    } catch (error) {
      console.error(error);
      notifications.show({
        title: "Lỗi",
        message: `Có lỗi xảy ra khi ${idEdit !== undefined ? "chỉnh sửa" : "tạo"} quyền chuyển kho!`,
        color: "red",
        icon: <IconX size={18} />,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetDataDetail = async () => {
      const response = await repositoryMdm.get<MessageResponse<any>>(
        "/api/v1/TblGrantTransferRights/detail?nhanvienId=" + Number(idEdit),
      );
      console.log("Loggresponse", response);
      if (response && response.success && response.data) {
        const detail = response.data;
        form.setValues({
          nhanVienId: detail.nhanVienId,
          cnDiId: detail.cnDiId || [],
          cnDenId: detail.cnDenId || [],
        });
      }
    };
    if (idEdit !== undefined) fetDataDetail();
  }, [idEdit]);

  return (
    <Box mt={10}>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid gutter="md">
          <GridCol span={12}>
            <Select
              label="Nhân viên"
              placeholder="Chọn nhân viên"
              searchable
              clearable={!idEdit}
              value={
                form.getValues().nhanVienId &&
                String(form.getValues().nhanVienId).length > 0
                  ? String(form.getValues().nhanVienId)
                  : null
              }
              readOnly={idEdit !== undefined}
              withAsterisk
              data={dataEmployee
                .filter((item) => item.id && item.code)
                .map((item) => ({
                  label: `${item.code} - ${item.fullname}`,
                  value: String(item.id),
                }))}
              leftSection={<IconUserCode color="#15aabf" size={18} />}
              nothingFoundMessage="Không tìm thấy dữ liệu!"
              // {...form.getInputProps('nhanVienId')}
              onChange={(value) => {
                const cnDenIdSelect =
                  dataEmployee.find((i) => String(i.id) === String(value))
                    ?.branchId || null;

                form.setValues((prev) => ({
                  ...prev,
                  nhanVienId: value ? Number(value) : undefined,
                  cnDenId: cnDenIdSelect ? [String(cnDenIdSelect)] : [],
                }));
              }}
              error={form.errors.nhanVienId}
            />
          </GridCol>

          <GridCol span={12}>
            <MultiSelect
              label="Chi nhánh đi"
              placeholder="Chọn chi nhánh đi"
              searchable
              clearable
              withAsterisk
              value={form.getValues().cnDiId}
              data={[
                { label: "Tất cả", value: "Tất cả" },
                ...dataBranch
                  .filter((ele) => ele.att2 && ele.text && ele.value)
                  .map((ele) => ({
                    label: ele.att2 + " - " + ele.text,
                    value: ele.value,
                  })),
              ]}
              leftSection={<IconTransferOut color="#15aabf" size={18} />}
              nothingFoundMessage="Không tìm thấy dữ liệu!"
              // {...form.getInputProps('cnDiId')}
              onChange={(value) => {
                if (value.includes("Tất cả")) {
                  form.setFieldValue(
                    "cnDiId",
                    dataBranch
                      .filter((ele) => ele.att2 && ele.text && ele.value)
                      .map((ele) => String(ele.value)),
                  );
                } else {
                  form.setFieldValue("cnDiId", value);
                }
              }}
              error={form.errors.cnDiId}
            />
          </GridCol>

          <GridCol span={12}>
            <MultiSelect
              label="Chi nhánh đến"
              placeholder="Chọn chi nhánh đến"
              searchable
              clearable
              withAsterisk
              value={form.getValues().cnDenId}
              data={[
                { label: "Tất cả", value: "Tất cả" },
                ...dataBranch
                  .filter((ele) => ele.att2 && ele.text && ele.value)
                  .map((ele) => ({
                    label: ele.att2 + " - " + ele.text,
                    value: ele.value,
                  })),
              ]}
              leftSection={<IconTransferIn color="#15aabf" size={18} />}
              nothingFoundMessage="Không tìm thấy dữ liệu!"
              // {...form.getInputProps('cnDenId')}
              onChange={(value) => {
                if (value.includes("Tất cả")) {
                  form.setFieldValue(
                    "cnDenId",
                    dataBranch
                      .filter((ele) => ele.att2 && ele.text && ele.value)
                      .map((ele) => String(ele.value)),
                  );
                } else {
                  form.setFieldValue("cnDenId", value);
                }
              }}
              error={form.errors.cnDenId}
            />
          </GridCol>
        </Grid>

        <Box
          mt={10}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Button
            variant="outline"
            onClick={() => modals.closeAll()}
            disabled={isLoading}
          >
            Hủy
          </Button>
          <Button type="submit" loading={isLoading} color="blue">
            {idEdit !== undefined ? "Chỉnh sửa" : "Thêm mới"}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default ModalCreateRequestManagerTransfer;
